var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Property, ChildProperty, Browser } from '@syncfusion/ej2-base';
export class SmithchartFont extends ChildProperty {
}
__decorate([
    Property('Segoe UI')
], SmithchartFont.prototype, "fontFamily", void 0);
__decorate([
    Property('Normal')
], SmithchartFont.prototype, "fontStyle", void 0);
__decorate([
    Property('Regular')
], SmithchartFont.prototype, "fontWeight", void 0);
__decorate([
    Property('')
], SmithchartFont.prototype, "color", void 0);
__decorate([
    Property('12px')
], SmithchartFont.prototype, "size", void 0);
__decorate([
    Property(1)
], SmithchartFont.prototype, "opacity", void 0);
export class SmithchartMargin extends ChildProperty {
}
__decorate([
    Property(Browser.isDevice ? 5 : 10)
], SmithchartMargin.prototype, "top", void 0);
__decorate([
    Property(Browser.isDevice ? 5 : 10)
], SmithchartMargin.prototype, "bottom", void 0);
__decorate([
    Property(Browser.isDevice ? 5 : 10)
], SmithchartMargin.prototype, "right", void 0);
__decorate([
    Property(Browser.isDevice ? 5 : 10)
], SmithchartMargin.prototype, "left", void 0);
export class SmithchartBorder extends ChildProperty {
}
__decorate([
    Property(0)
], SmithchartBorder.prototype, "width", void 0);
__decorate([
    Property(1)
], SmithchartBorder.prototype, "opacity", void 0);
__decorate([
    Property('transparent')
], SmithchartBorder.prototype, "color", void 0);
/**
 * Internal use of type rect
 */
export class SmithchartRect {
    constructor(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
}
export class LabelCollection {
}
export class LegendSeries {
}
export class LabelRegion {
}
export class HorizontalLabelCollection extends LabelCollection {
}
export class RadialLabelCollections extends HorizontalLabelCollection {
}
export class LineSegment {
}
export class PointRegion {
}
/**
 * Smithchart internal class for point
 */
export class Point {
}
export class ClosestPoint {
}
export class MarkerOptions {
    constructor(id, fill, borderColor, borderWidth, opacity) {
        this.id = id;
        this.fill = fill;
        this.borderColor = borderColor;
        this.borderWidth = borderWidth;
        this.opacity = opacity;
    }
}
export class SmithchartLabelPosition {
}
export class Direction {
    constructor() {
        this.counterclockwise = 0;
        this.clockwise = 1;
    }
}
export class DataLabelTextOptions {
}
export class LabelOption {
}
/** @private */
export class SmithchartSize {
    constructor(width, height) {
        this.width = width;
        this.height = height;
    }
}
export class GridArcPoints {
}
